/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FailedNotificationDto { 
    id?: string;
    notificationType?: FailedNotificationDto.NotificationTypeEnum;
    entityId?: string;
    entityType?: FailedNotificationDto.EntityTypeEnum;
    recipients?: Array<string>;
    subject?: string;
    status?: FailedNotificationDto.StatusEnum;
    errorMessage?: string;
    retryCount?: number;
    firstFailedAt?: string;
    lastAttemptAt?: string;
    resolvedAt?: string;
}
export namespace FailedNotificationDto {
    export const NotificationTypeEnum = {
        OrderReadyForConfiguration: 'ORDER_READY_FOR_CONFIGURATION',
        OrderItemSubmittedForReview: 'ORDER_ITEM_SUBMITTED_FOR_REVIEW',
        OrderItemMovedToProduction: 'ORDER_ITEM_MOVED_TO_PRODUCTION',
        OrderShipped: 'ORDER_SHIPPED',
        OrderReminderDue: 'ORDER_REMINDER_DUE',
        RmaSubmittedByCustomer: 'RMA_SUBMITTED_BY_CUSTOMER',
        RmaQuoteRequired: 'RMA_QUOTE_REQUIRED',
        RmaPackageReceived: 'RMA_PACKAGE_RECEIVED',
        RmaDeviceDataAvailable: 'RMA_DEVICE_DATA_AVAILABLE',
        RmaInspectionCompleted: 'RMA_INSPECTION_COMPLETED',
        RmaAddedByAdmin: 'RMA_ADDED_BY_ADMIN'
    } as const;
    export type NotificationTypeEnum = typeof NotificationTypeEnum[keyof typeof NotificationTypeEnum];
    export const EntityTypeEnum = {
        Order: 'ORDER',
        Rma: 'RMA'
    } as const;
    export type EntityTypeEnum = typeof EntityTypeEnum[keyof typeof EntityTypeEnum];
    export const StatusEnum = {
        Failed: 'FAILED',
        Resolved: 'RESOLVED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


export type NotificationTypeEnum = typeof FailedNotificationDto.NotificationTypeEnum[keyof typeof FailedNotificationDto.NotificationTypeEnum];
export type EntityTypeEnum = typeof FailedNotificationDto.EntityTypeEnum[keyof typeof FailedNotificationDto.EntityTypeEnum];
